import { Api } from './api';

export const ParkingService = {
  regionRules: () => Api.get('/region-rules', { headers: {'Authorization': sessionStorage.getItem('token')} }),
}
